import { memo } from 'react'

import OutboundLink from '@/components/OutboundLink/OutboundLink'
import getRandomAd from '@/utils/getRandomAd'

import styles from './Adhesion.module.scss'

const Adhesion = () => {
  const randomAdMobile = getRandomAd('tcg.land/mobile')
  const randomAdDesktop = getRandomAd('tcg.land/desktop')
  return (
    <div className={styles.container}>
      <OutboundLink url='https://www.tcg.land/promos/junio-2025-final-fantasy' utm_medium='adhesion-mobile'>
        <img alt='TCG.Land' className='d-flex d-md-none' src={randomAdMobile.src} />
      </OutboundLink>
      <OutboundLink url='https://www.tcg.land/promos/junio-2025-final-fantasy' utm_medium='adhesion-desktop'>
        <img alt='TCG.Land' className='d-none d-md-flex' src={randomAdDesktop.src} />
      </OutboundLink>
    </div>
  )
}

export default memo(Adhesion)
